// extracted by mini-css-extract-plugin
module.exports = {"exerciseBox8":"L8_exerciseBox8__3p5_7","mspacing":"L8_mspacing__14z4l","mspacing2":"L8_mspacing2__2RpvR"};